// Unpublished Work © 2021-2023 Deere & Company

import React from 'react';
import {Redirect, Switch} from 'react-router-dom';
import {getRouteMaps} from '../../factories/route-maps';
import styles from './customer-routes.module.scss';
import {useSelector} from 'react-redux';
import {WalkMeHiddenUserHooks} from './walk-me-hidden-user-hooks';

export const CustomerRoutes = () => {
    const configuration = useSelector((state) => state.configuration);
    const routesMap = getRouteMaps(configuration.businessActivities, configuration.restrictAccess());
    const routes = Object.values(routesMap);

    return routes.length ? (
        <section className={styles.appContent}>
            <WalkMeHiddenUserHooks/>
            <Switch>
                {
                    routes.map((route, index) =>
                        React.cloneElement(route, {
                            key: index
                        }))
                }
            </Switch>
        </section>
    ) : <Redirect to='/no-access'/>;
};
